<template>
  <div class="achievement">
    <div class="tab">
      <span :class="activeTab==3?'activeTab':''"
            @click="tab(3)">专栏</span>
      <span :class="activeTab==1?'activeTab':''"
            @click="tab(1)">单课</span>
      <span :class="activeTab==4?'activeTab':''"
            @click="tab(4)">会员</span>
    </div>
    <div class="carList">
      <!--会员格式显示-->
      <div v-if="activeTab==4">
          <div class="item"
           v-for="(item,index) in list"
           :key="index">
        <div class="itemT">
          <div>
            <span><b>购买CMDHRA
              <span v-if="item.type==1">个人会员 {{ item.mname }}</span>

              <span v-if="item.type==2">企业会员</span></b> </span>
              
          </div>
          <div ><span style="color:red;">￥ {{item.mprice}}</span></div>
          <div>
            <span>充值时间：{{item.purchaseTime}} </span>
          </div>
        </div>
      </div>
      </div>
      <!--之前两个格式显示-->
      <div v-if="activeTab!=4">
        <div class="item"
            v-for="item in list"
            :key="item.orderNo"
            @click="goRun(item)">
          <div class="itemT">
            <div>
              <span>订单编号：{{item.orderNo}}</span>
            </div>
            <div>
              <span>下单时间：{{getTimes(item.createTime)}}</span>
            </div>
          </div>
          <div class="itemM">
            <div class="itemMlet">
              <img :src="item.url"
                  alt />
            </div>
            <div class="itemMrigt">
              <!-- <div>
                <span v-html="item.abstract">{{item.abstract}}</span>
              </div> -->
              <div class="itemTip">
                <span>{{item.title}}</span>
              </div>
              <div class="itemSpeak">
                <span>{{item.speaker}}</span>
              </div>
            </div>
          </div>
          <div class="itemB">

            <span>已支付￥{{item.payPrice}}</span>
            <span class="buyState">{{item.orderStatus==0?'未支付':item.orderStatus==1?'支付成功':'支付失败'}}</span>
          </div>
        </div>
      </div>

    </div>
    <div class="wrapB"
         @click="goPage">
      <span>先去逛逛>></span>
    </div>
  </div>
</template>
<script>
import iVideolist from "../container/videoList";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
export default {
  data () {
    return {
      activeTab: 1,
      itemId: 1,
      wxuser: null,
      list: []
    };
  },
  props: {},
  async mounted () {
    this. wxuser=await loginService.getLoginUser();

    this.getList();
  },
  methods: {
    getTimes (value) {
      let val = new Date(value).getTime();
      return new Date(val).Format("yyyy-MM-dd hh:mm");
    },
    listShow (val) {
      this.itemId = val;
      // this.getList()
    },
    tab (val) {
      this.activeTab = val;
      this.getList();
    },
    getList () {
      
      if(this.activeTab == 4){
        this.$postHttp(AppSetting.baseUrl + "/memberitem/queryByUserMenberLog", {
          uId:this.wxuser.uId
        }).then(res => {
          if (res.data.code == 0) {
            this.list = res.data.list;
          }
        });
      }else{
        this.$postHttp(AppSetting.baseUrl + "/order/app/pageList", {
          uid: this.wxuser.uId,
          orderType: this.activeTab
        }).then(res => {
          if (res.data.code == 0) {
            this.list = res.data.list;
          }
        });
      }

    },
    goPage () {
      if (this.activeTab == 3) {
        this.$router.push({
          name: "Column",
          query: {}
        });
      }else if(this.activeTab == 4){
        this.$router.push({
          name: "Me",
          query: {}
        });
      } else {
        this.$router.push({
          name: "Video",
          query: {}
        });
      }
    },
    goRun (item) {
      // 1 视频购买，2直播购买，3会议购买
      if (item.orderType == 1) {
        this.$router.push({
          name: 'vDetails',
          query: {
            type: 'video',
            videoId: item.bId


          }
        })

      } else if (item.orderType == 2) {
        this.$router.push({
          name: 'Details',
          query: {
            type: 'live',
            liveId: item.bId
          }
        })

      } else {
        this.$router.push({
          name: 'colDetails',
          query: {
            type: 'column',
            colId: item.bId
          }
        })

      }
    }
  },
  components: {},
  computed: {},
  activated() {
    if (this.$route.meta.keepAliveChange) {
      this.getList();
    }
    document.title = "我的已购";
  }

};
</script>
<style scoped lang="scss">
.achievement {
  width: 100%;
  height: 100%;
  background: #f4f5f4;
  min-height: 100vh;

  .tab {
    width: 100%;
    display: flex;
    font-size: 0.3rem;
    color: #333;
    text-align: center;
    line-height: 0.8rem;
    background: #fff;
    padding: 0px 0.3rem;
    box-sizing: border-box;
    span {
      flex: 1;
      padding: 0px 0.15rem;
      box-sizing: border-box;
    }
  }
  .activeTab {
    color: #05a2ff;
    font-size: 0.34rem;
    border-bottom: 0.01rem solid #05a2ff;
  }
  .search {
    padding: 0.33rem 0.29rem;
    box-sizing: border-box;
    overflow: hidden;
    .searchLet {
      float: left;
      width: 20%;
      font-size: 0.3rem;
      color: #333;
      line-height: 0.7rem;
    }

    .search_inp {
      float: left;
      height: 0.7rem;
      line-height: 0.7rem;
      width: 80%;
      position: relative;
      padding-right: 0.15rem;
      // border-radius: 0.15rem;
      box-sizing: border-box;
      // background:rgba(238,238,238,1);
      input {
        background: none;
        outline: none;
        border: none;
        display: inline-block;
        position: absolute;
        top: 0px;
        left: 0.3rem;
        width: 98%;
        height: 90%;
        outline: none;
        border-radius: 0.15rem;
        box-sizing: border-box;
        padding: 0 0.3rem;
        background: rgba(238, 238, 238, 1);
      }
      .searchBnt {
        width: 0.28rem;
        height: 0.28rem;
        position: absolute;
        right: 0.15rem;
        top: 50%;
        margin-top: -0.14rem;
        // background: url("../../assets/images/search.png");
        background-size: 100% 100%;
      }
    }
  }
  .carList {
    padding: 0.2rem;
    box-sizing: border-box;
    .item {
      padding-bottom: 0.12rem;
      font-size: 0.3rem;
      color: #333;
      background: #fff;
      border-radius: 0.1rem;
      padding: 0.2rem;
      box-sizing: border-box;
      margin-bottom: 0.3rem;
    }
    .itemT {
      border-bottom: 0.01rem solid #dcdcdc;
      padding: 0.2rem;
      box-sizing: border-box;
      div:first-child {
        font-size: 0.26rem;
        color: #333333;
      }
      div:last-child {
        font-size: 0.24rem;
        color: #666666;
        //margin-top: 0.2rem;
      }
    }
    .itemM {
      padding: 0.37rem 0.22rem;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      .itemMlet {
        width: 2rem;
        height: 1.1rem;
        background: #dcdcdc;
        float: left;
        img {
          width: 100%;
          max-height: 1.1rem;
        }
      }
      .itemMrigt {
        width: calc(100% - 2rem);
        padding-left: 0.1rem;
        box-sizing: border-box;
        float: left;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        div {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .itemTip {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          font-size: 0.28rem;
          color: #666666;
          // margin-top: 0.2rem;
        }
        .itemSpeak {
          font-size: 0.24rem;
          color: #666666;
        }
      }
    }
    .itemB {
      border-top: 0.01rem solid #dcdcdc;
      font-size: 0.24rem;
      line-height: 0.73rem;
      s {
        margin-right: 0.15rem;
      }
    }
    .buyState {
      float: right;
      font-size: 0.28rem;
      font-weight: 800;
      color: #dd0202;
    }
  }
  .wrapB {
    font-size: 0.26rem;
    color: #1a8bff;
    text-align: center;
    padding: 0.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/myBuy.vue